import { useEffect, useCallback, useState } from "react";
import {
  useRegionListRequest,
  useCountryListRequest,
  useStoreTypeListRequest,
  useUserGetPosRequest
} from "../../hooks/useApi";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '../Icons/CloseIcon';
import '../SelectStoreModal/styles.css';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import UserPos from '../../components/UserPos';
import MainBtn from '../../components/MainBtn';
import TextField from '@mui/material/TextField';
import debounce from 'lodash.debounce';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: "10px",
  boxShadow: 24,
  pt: 2,
  pb: 3,
};

export default function ChangeStore({open, setOpenModal, handleClose, setSelectedPosId, selectedPosId})
{
  const [{loadingRegions}, getRegionList] = useRegionListRequest();
  const [{loadingCountries}, getCountriesList] = useCountryListRequest();
  const [{loadingStoreTypes}, getStoreTypesList] = useStoreTypeListRequest();
  const [{loadingUserPos}, getUserPos] = useUserGetPosRequest();
  const modalParams = JSON.parse(localStorage.getItem('changeStoreParams'));
  const [selectedRegion, setRegion] = useState(modalParams?.selectedRegion || '');
  const [selectedCountry, setCountry] = useState(modalParams?.selectedCountry || '');
  const [selectedStoreType, setStoreType] = useState(modalParams?.selectedStoreType || '');
  const [freeText, setFreeText] = useState(null);
  const [modalPosId, setModalPosId] = useState(selectedPosId || '');
  const [selectedStoreName, setSelectedStoreName] = useState(modalParams?.selectedStoreName || '');

  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);

  const [userPosRows, setUserPosRows] = useState([]);

  const handleChangeRegion = (event) =>
  {
    const {target: {value}} = event;
    setRegion(value);
    setCountry('');
    setStoreType('');
    setModalPosId('');
  };
  const handleChangeCountry = (event) =>
  {
    const {target: {value}} = event;
    setCountry(value);
    setStoreType('');
    setModalPosId('');
  };
  const handleChangeStoreType = (event) =>
  {
    const {target: {value}} = event;
    setStoreType(value);
    setModalPosId('');
  };

  const FetchRegionList = useCallback(async () =>
  {
    const aaa = async () =>
    {
      const response = await getRegionList({});
      setRegions(JSON.parse(response.data));
    };
    await aaa();
  }, []);

  const FetchCountriesList = useCallback(async () =>
  {
    const aaa1 = async () =>
    {
      const queryParams = {region: selectedRegion};
      const response = await getCountriesList({queryParams});
      setCountries(JSON.parse(response.data));
    };
    await aaa1();
  }, [selectedRegion, setRegion]);

  const FetchStoreTypesList = useCallback(async () =>
  {
    const aaa2 = async () =>
    {
      const queryParams = {region: selectedRegion, countryId: selectedCountry};
      const response = await getStoreTypesList({queryParams});
      setStoreTypes(JSON.parse(response.data));
    };
    await aaa2();
  }, [selectedCountry, setCountry]);

  const FetchUserPos = useCallback(async () =>
  {
    const aaa3 = async () =>
    {
      if (!selectedRegion && !selectedCountry && !selectedStoreType)
      {
        setUserPosRows([]);
        return [];
      }
      const bodyParams = {
        virtualStoreIds: selectedRegion ? [selectedRegion] : [],
        countryIds: selectedCountry ? [selectedCountry] : [],
        posTypeIds: selectedStoreType ? [selectedStoreType] : [],
        freeText: freeText
      };
      const response = await getUserPos({bodyParams});
      setUserPosRows(response.data.elements);
    };
    await aaa3();
  });

  useEffect(() =>
  {
    FetchRegionList();
    // If we have a selectedPosId but no selectedStoreName, fetch all stores to find the name
    if (selectedPosId && !selectedStoreName)
    {
      const fetchStoreName = async () =>
      {
        try
        {
          const response = await getUserPos({
            bodyParams: {
              virtualStoreIds: [],
              countryIds: [],
              posTypeIds: [],
              freeText: null
            }
          });
          if (response?.data?.elements)
          {
            const store = response.data.elements.find(s => s.posId === selectedPosId);
            if (store)
            {
              setSelectedStoreName(store.posDs);
            }
          }
        } catch (error)
        {
          console.error('Error fetching store name:', error);
        }
      };
      fetchStoreName();
    }
  }, []);

  useEffect(() =>
  {
    FetchCountriesList();
  }, [selectedRegion, setRegion]);

  useEffect(() =>
  {
    FetchStoreTypesList();
  }, [selectedCountry, setCountry]);

  useEffect(() =>
  {
    FetchUserPos();
  }, [selectedStoreType, setStoreType, selectedCountry, setCountry, selectedRegion, setRegion]);

  const handleChangePosId = async (event) =>
  {
    const {target: {value}} = event;
    setModalPosId(value);
    // Find the store name for the selected posId
    const selectedStore = userPosRows.find(row => row.posId === value);
    if (selectedStore)
    {
      setSelectedStoreName(selectedStore.posDs);
    }
  }

  const debouncedSave = useCallback(
    debounce(async (event, valueToUse) =>
    {
      const {target: {value, name}} = event;
      setFreeText(valueToUse);
      const bodyParams = {
        virtualStoreIds: selectedRegion ? [selectedRegion] : [],
        countryIds: selectedCountry ? [selectedCountry] : [],
        posTypeIds: selectedStoreType ? [selectedStoreType] : [],
        freeText: valueToUse
      };
      const response = await getUserPos({bodyParams});
      setUserPosRows(response.data.elements);
      setModalPosId('');

    }, 1500),
    [], // will be created only once initially
  );

  const handleFreeTextChange = async (event) =>
  {
    const {target: {value, name}} = event;
    setFreeText(value);

    debouncedSave(event, value);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{...style, width: 720, maxHeight: 821}}>
          <div className="modalTitle dFlex justifyContentSpaceBetween">
            <h2 className="">Change store</h2>
            <a className='close' onClick={handleClose}>
              <CloseIcon/>
            </a>
          </div>
          <hr/>
          <div className="modalBody">
            {selectedPosId && (
              <div className="current-store-display">
                <div className="current-store-label">Current selected store:</div>
                <div className="current-store-value">
                  {selectedStoreName || 'Store'} | {selectedPosId}
                </div>
              </div>
            )}
            <div className='grid grid-cols-3 gap-3'>
              <FormControl>
                <InputLabel id="region-label">Region</InputLabel>
                <Select
                  labelId="region-label"
                  id="region"
                  value={selectedRegion}
                  onChange={handleChangeRegion}
                  input={<OutlinedInput label="Region"/>}
                  size="small"
                  sx={{
                    p: 0,
                    fontSize: '24px',
                    color: '#828282',
                    fontFamily: "LatoRegular",
                  }}
                >
                  {regions.map(({regionId, regionDs}) => (
                    <MenuItem key={regionId} value={regionId}>
                      <ListItemText primary={regionDs}/>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <InputLabel id="nation-label">Nation</InputLabel>
                <Select
                  labelId="nation-label"
                  id="nation"
                  value={selectedCountry}
                  onChange={handleChangeCountry}
                  input={<OutlinedInput label="Nation"/>}
                  size="small"
                  sx={{
                    p: 0,
                    fontSize: '24px',
                    color: '#828282',
                    fontFamily: "LatoRegular",
                  }}
                >
                  {countries.map(({countryId, countryDs}) => (
                    <MenuItem key={countryId} value={countryId}>
                      <ListItemText primary={countryDs}/>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <InputLabel id="store-type-label">Store type</InputLabel>
                <Select
                  labelId="store-type-label"
                  id="store-type"
                  value={selectedStoreType}
                  onChange={handleChangeStoreType}
                  input={<OutlinedInput label="Store type"/>}
                  size="small"
                  sx={{
                    p: 0,
                    fontSize: '24px',
                    color: '#828282',
                    fontFamily: "LatoRegular",
                  }}
                >
                  {storeTypes.map(({posTypeId, posTypeDs}) => (
                    <MenuItem key={posTypeId} value={posTypeId}>
                      <ListItemText primary={posTypeDs}/>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className='grid grid-cols-1 gap-3 mt-4'>
              <TextField onChange={handleFreeTextChange} id="outlined-basic" label="Store" variant="outlined"/>
            </div>
            <div className="posTableWrapper mt-4">
              {userPosRows.length > 0 && (
                <UserPos
                  rows={userPosRows}
                  modalPosIds={modalPosId ? {[modalPosId]: true} : {}}
                  handleChangePosId={handleChangePosId}
                  singleSelect={true}
                />)}
            </div>
          </div>
          <hr/>
          <div className="modalFooter">
            <div className="flex place-content-between">
              {!modalPosId && (<>No store selected</>)}
              {modalPosId && (<>1 store selected</>)}
              <div className="flex place-content-between alignItemsCenter">
                <a className="footerCancel" onClick={handleClose}>Cancel</a>
                <MainBtn title="Confirm selected" onClick={() =>
                {
                  setSelectedPosId(modalPosId);
                  localStorage.setItem('changeStoreParams', JSON.stringify({
                    selectedRegion: selectedRegion,
                    selectedCountry: selectedCountry,
                    selectedStoreType: selectedStoreType,
                    selectedPosId: modalPosId,
                    selectedStoreName: selectedStoreName,
                  }));
                  window.dispatchEvent(new Event('changeStoreParamsUpdated'));
                  setOpenModal(false);
                }}/>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
